export default "__VITE_ASSET__1bfd5377__"